<div class="orders-container">
    <div *ngIf="!selectedOrder && !isLoading()">

      <div class="dashboard-top">
				<button mat-icon-button  color="primary" (click)="reload()">
						<mat-icon>sync</mat-icon>
				</button>
			</div>
			<div class="dashboard-header">
				<button type="button" (click)="goBack()" mat-button>
					<mat-icon>chevron_left</mat-icon>
				</button>
				<h2 class="webapp-title-secondary">Shopify Orders</h2>
      </div>

      <div class="table-wrapper">
        <table class="table table-hover orders-table">
            <thead>
            <tr>
              <th><i class="fas fa-user-tag"></i>client ID</th>
                <th><i class="fas fa-barcode"></i>Code</th>
                <th><i class="fas fa-box-open"></i>Data</th>
                <th><i class="fas fa-calendar-alt"></i> Created At</th>
                <th><i class="fas fa-info-circle"></i> Status</th>
                <th><i class="fas fa-info-circle"></i> Actions</th>
                <!-- <th><i class="fas fa-user-tag"></i> Order ID</th> -->
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let order of shopifyOrders" class="table-row">
              <td><i class="fas fa-id-card"></i> {{ order.FK_ID_clientDetails }}</td>
                <td (click)="copyCode(order)"><i class="fas fa-hashtag"></i><span class="info-badge">{{ order.orderCode }}</span> </td>
                <td (click)="viewOrderDetails(order)"><i class="fas fa-box"></i> <app-smart-text [limit]="28" [text]="order.orderInfo"></app-smart-text></td>
                <td><i class="fas fa-clock"></i> {{ order.createdAt }}</td>
                <td *ngIf="order.status == 'paid'"><span class="status paid">Paid</span></td>
                <td *ngIf="order.status == 'unpaid'"><span class="status unpaid">Unpaid</span></td>
                <td *ngIf="order.status == 'pending'"><span class="status pending">Pending</span></td>
                <td *ngIf="order.status == 'paymentPending'"><span class="status pending">Verify Payment</span></td>
                <td *ngIf="order.status == 'processing'"><span class="status processing">Processing</span></td>
                <td *ngIf="!order.status"><span class="status">Undefined</span></td>
                <!-- <td><i class="fas fa-boox"></i>{{ order.id }}</td> -->
                <td>
                  <button mat-icon-button color="warn" (click)="deleteOrder(order.id)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
            </tr>
            </tbody>
        </table>
      </div>
    </div>

    <mat-spinner *ngIf="isLoading()"></mat-spinner>
  
    <!-- Order Details -->
    <div class="order-details" *ngIf="selectedOrder">
      <div class="details-header">
        <h3 class="details-title"><i class="fas fa-info-circle"></i> Order Details</h3>
        <button class="btn btn-sm btn-outline-secondary close-btn" (click)="closeDetails()">
          <i class="fas fa-times"></i> Close
        </button>
      </div>
      <div class="details-content">
        <p><strong><i class="fas fa-receipt"></i> Order ID:</strong> {{ selectedOrder.id }}</p>
        <p><strong><i class="fas fa-barcode"></i> Order Code:</strong> {{ selectedOrder.orderCode }}</p>
        <p><strong><i class="fas fa-calendar"></i> Created At:</strong> {{ selectedOrder.createdAt }}</p>
        <p><strong><i class="fas fa-user"></i> Client:</strong> {{ getCustomerName() }} ({{ getCustomerEmail() }})</p>
        <p><strong><i class="fas fa-map-marker-alt"></i> Address:</strong> {{ getAddress() }}</p>
      </div>
      <h4 class="products-title"><i class="fas fa-box"></i> Products in Order</h4>
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th>Quantity</th>
              <th>Price</th>
              <th>Product ID</th>
              <th>SKU</th>
              <th>Title</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let product of getOrderProducts()">
              <td>{{ product.quantity }}</td>
              <td>${{ product.price }}</td>
              <td>{{ product.product_id }}</td>
              <td>{{ product.sku }}</td>
              <td>{{ product.title }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  
  <h4 class="webapp-title-secondary">Product activation</h4>
  <ol class="breadcrumb">
      <li class="breadcrumb-item">Products</li>
      <li class="breadcrumb-item active" aria-current="page"><a href="javascript: void(0)" (click)="goToCrudView('productActivation')">Product activation</a></li>
  </ol>